/* tslint:disable:no-input-rename no-output-rename variable-name */
import {Directive, ElementRef, Input, OnDestroy} from '@angular/core';
import {AbsoluteDragHandleDirective} from '@shared/absolute-drag/absolute-drag-handle.directive';
import {ABSOLUTE_DRAG_PARENT} from '@shared/absolute-drag/injection-tokens';
import {Subject} from 'rxjs';
import {Point} from '@angular/cdk/drag-drop';

/** Element that can be moved inside a CdkDropList container. */
@Directive({
  selector: '[absoluteDrag]',
  exportAs: 'absoluteDrag',
  providers: [{provide: ABSOLUTE_DRAG_PARENT, useExisting: AbsoluteDragDirective}],
})
export class AbsoluteDragDirective<T = any> implements OnDestroy {
  private static dragInstances: Map<number, AbsoluteDragDirective> = new Map<number, AbsoluteDragDirective>();
  private static lastId = 0;

  private _id: number;
  get id() {
    return this._id;
  };

  private destroyed = new Subject<void>();

  public handleInstance: AbsoluteDragHandleDirective;

  /** Arbitrary data to attach to this drag instance. */
  @Input('absoluteDragData') data: T;

  constructor(public element: ElementRef<HTMLElement>) {
    // We have to keep track of the drag instances in order to be able to match an element to
    // a drag instance. We can't go through the global registry of `DragRef`, because the root
    // element could be different.
    this._id = AbsoluteDragDirective.lastId++;
    AbsoluteDragDirective.dragInstances.set(this._id, this);
  }

  public static getInstance(id: number) {
    if (!AbsoluteDragDirective.dragInstances.has(id)) {
      return null;
    }

    return AbsoluteDragDirective.dragInstances.get(id);
  }

  public ngOnDestroy() {
    if (AbsoluteDragDirective.dragInstances.has(this._id)) {
      AbsoluteDragDirective.dragInstances.delete(this._id);
    }

    this.destroyed.complete();
  }

  public getDragHandlePoint(): Point {
    const rect = (this.handleInstance.element.nativeElement as HTMLElement).getBoundingClientRect();
    return {
      x: rect.x,
      y: rect.y
    };
  }

  public getDragElementPoint(): Point {
    const rect = (this.element.nativeElement as HTMLElement).getBoundingClientRect();
    return {
      x: rect.x,
      y: rect.y
    };
  }
}
